<mat-form-field disabled="true" class="example-chip-list" fxFill>
  <mat-label>What type of service do you provide?</mat-label>
  <mat-chip-list #tagList aria-label="Tag selection">
    <mat-chip
      *ngFor="let tag of tags"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="remove(tag)"
    >
      {{ tag }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
    <input
      #tagInput
      [formControl]="tagCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="tagList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
      {{ tag }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
